import React from 'react';

function Community() {
  return (
    <section className="py-12 px-4 md:px-12 bg-gray-50 min-h-screen">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-6 text-gray-800">🎮 Komunitas RF FUN SERVER</h2>
        <p className="text-gray-600 mb-8">
          Bergabunglah dengan ratusan player aktif, diskusi antar bangsa, pengumuman event, dan live support langsung dari admin.
        </p>

        <div className="flex justify-center">
          <iframe
            title="Discord Widget"
            src="https://discord.com/widget?id=1012013614636486826&theme=dark"
            width="100%"
            height="500"
            allowTransparency="true"
            frameBorder="0"
            sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
            className="rounded shadow-lg max-w-3xl w-full"
          ></iframe>
        </div>
      </div>
    </section>

    
  );
}

export default Community;
